angular.module('trainerWebApp.resources').factory('CustomCertificateResolver',
  ['$q', '$route', '$location', 'errorHandler', 'customCertificateResource', 'mtypes', 'Auth', function ($q, $route, $location, errorHandler, customCertificateResource, mtypes, Auth) {
    return function () {
      var deferred = $q.defer();
      var courseId = $route.current.params.courseId || $route.current.params.seriesId;
      var queryParams = $location.search();
      var hasPermission = !!~mfConfig.features.indexOf(mtypes.featureEntry.customCertificate) && Auth.hasUserPrivilege(mtypes.userPrivilege.canEditCourses);

      if (queryParams || hasPermission) {
        // ugly, we have to write the custom cert rows to make preview etc work
        customCertificateResource.saveCustomCertificate({courseId: courseId}, function () {
          customCertificateResource.getCustomCertificateInfo(courseId, function (result) {
            deferred.resolve(result);
          }, errorHandler.defaultServerErrorHandler());
        }, errorHandler.defaultServerErrorHandler());
      } else {
        deferred.resolve({});
      }

      return deferred.promise;
    }
  }]
);
